@if (show) {
<div class="warning-notice" [class.zoom-out]="hide && applyZoomOut" [class.error]="isError">
  <div class="warning-content">
    <app-st-icon [filled]="true"
                 [color]="isError ? '#CB2A2F' : '#A35200'"
                 class="warning-icon"
                 [name]="isError ? 'dangerous' : 'warning'"
                 [bold]="true"></app-st-icon>
    <div class="warning-text">
      @if (titleTmpl) {
        <div class="warning-title">
          <ng-container [ngTemplateOutlet]="titleTmpl"></ng-container>
        </div>
      }
      @if (messageTmpl) {
        <div class="warning-message">
          <ng-container [ngTemplateOutlet]="messageTmpl"></ng-container>
        </div>
      }
      @if (actionTmpl) {
        <div class="warning-action">
          <ng-container [ngTemplateOutlet]="actionTmpl"></ng-container>
        </div>
      }
    </div>
  </div>
</div>
}
